import { useEffect, useState } from "react";
import { getSearchTopSale } from "../../server/product";
import ProductCard from "../../components/ProductCard";
import { Skeleton } from "../../components/Skeleton";

export default function SellingHot() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const res = await getSearchTopSale();
        setData(res ?? []);
      } catch (error) {
        console.error("Error load SellingHot:", error);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  if (loading) {
    return (
      <section className="relative px-4 py-10">
        <div className="mx-auto flex max-w-7xl flex-col gap-6">
          <div className="flex items-start justify-between gap-4">
            <div>
              <Skeleton className="h-4 w-20" />
              <Skeleton className="mt-2 h-6 w-48" />
              <Skeleton className="mt-2 h-3 w-64" />
            </div>
            <div className="hidden items-center gap-2 md:flex">
              {Array.from({ length: 2 }).map((_, idx) => (
                <Skeleton key={idx} className="h-6 w-24 rounded-full" />
              ))}
            </div>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            {Array.from({ length: 5 }).map((_, idx) => (
              <div key={idx} className="space-y-3 rounded-2xl border border-slate-100 bg-white p-3">
                <Skeleton className="h-36 w-full rounded-xl" />
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-4 w-1/2" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (!data || data.length === 0) return null;

  return (
    <section className="relative px-4 py-10">
      <div className="mx-auto flex max-w-7xl flex-col gap-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="section-eyebrow">Top Selling</p>
            <h3 className="section-title">Sản phẩm bán chạy nhất</h3>
            <p className="mt-1 text-sm text-slate-500">
              Cập nhật liên tục các mẫu bán chạy, sẵn kho giao ngay.
            </p>
          </div>
          <div className="hidden items-center gap-2 md:flex">
            <span className="chip text-xs">Hỗ trợ doanh nghiệp</span>
            <span className="chip text-xs">Giá tốt nhất</span>
          </div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {data.map((item) => (
            <ProductCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
